<template>
    <div class="mdc-dialog">
        <div class="mdc-dialog__container">
            <div class="mdc-dialog__surface"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="my-dialog-title"
                aria-describedby="my-dialog-content">
                <div class="mdc-dialog__content" id="my-dialog-content">
                    <div class="block md:hidden mb-6">
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="close">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label flex font-bold">
                                <img src="/img/icons/arrow-left.svg" alt="">
                                {{ $trans.get('about-teachers.go-back') }}
                            </span>
                        </button>
                    </div>
            <div class="hidden md:block mb-6 close-button">
                <button class="mdc-fab" aria-label="Favorite" data-mdc-dialog-action="close">
                <div class="mdc-fab__ripple"></div>
                <span class="mdc-fab__icon material-icons">close</span>
                </button>
            </div>
                    <div class="dialog-top-container">
                        <img v-if="teacher.image" :src="`/storage/${teacher.image}`" :alt="teacher.name">
                        <h3 class="my-6 text-black">{{teacher.name}}</h3>
                    </div>
                    <div class="mb-6" v-if="teacher">
                        <h6 class="text-black">{{ teacher.job[locale] }}</h6>
                        <h6 v-for="course in teacher.courses" :key="course.id" class="text-blue">
                            <a :href="course.path">{{ course.short_name[locale] }}</a>
                        </h6>
                    </div>
                    <div v-if="teacher">
                        <div class="mb-3 text-black" v-html="teacher.description[locale]"></div>
                    </div>
                    <div v-if="teacher">
                        <h6 class="my-6 text-black">{{ $trans.get('about-teachers.training') }}</h6>
                        <div class="mb-3 text-black" v-html="teacher.training[locale]"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mdc-dialog__scrim"></div>
    </div>
</template>
<script>
import {MDCRipple} from '@material/ripple';
export default {
    props:['teacher'],
    data() {
        return {
            locale: window.appLocale,
        };
    },
    mounted() {
        const fabRipple = new MDCRipple(document.querySelector('.mdc-fab'));
    },
}
</script>
<style lang="scss">
.mdc-dialog{
    z-index: 1000;
    ::-webkit-scrollbar {
        width: 7.7px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #00559a;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #555;
    }
    .close-button{
        position: absolute;
        top: -28px;
        right: -28px;
        z-index: 100;
    }
    .mdc-fab{
        background-color: #001c33;
    }
}
.mdc-dialog__container{
    position: relative;
    width: 100%;
    max-width: 700px;
    height: 100vh;
    max-height: 1050px;

    @media (min-width: 1024px) {
        width: 100%;
        max-width: 700px;
        height: 80%;
        max-height: 1050px;
    }

    .mdc-dialog__surface{
        width: 100%;
        max-width: 100%;
        top:46px;
        color: black;
        overflow: visible;
        @media (min-width: 1024px) {
            max-height: calc(100% - 32px);
            top:0;
        }
        .dialog-top-container{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img{
                max-width: 100%;
                width: 100%;
                @media (min-width: 1024px) {
                     max-width: 224px;
                }
            }
        }
        .text-blue{
            color: #00559a;
        }
        .text-black{
            color: black;
        }
        .mdc-button__label{
            color: black;
        }
        .mdc-fab__icon{
            font-size: 40px;
        }
    }
}
</style>
